// // src/utils/dashboardStatusLogic.js
// import { useState, useEffect } from "react";
// import Swal from "sweetalert2";
// import api from "../jsx/axiosClient";

// export function useDashboardStatus(userSession) {
//     const baseUrl = "https://stagingapi.chalachitravaachana.org/";
//     const [recentVideos, setRecentVideos] = useState([]);
//     const [dashboard_data , setDashboard_data] = useState([]);
//     const [stats, setStats] = useState({
//         uploaded: 0,
//         processing: 0,
//         published: 0,
//         corrupted: 0,
//     });

//     useEffect(() => {
      
//         const fetchDashboardData = async () => {
//             if (!userSession?.access_token) return;
//             try {
//                 console.log("access_token Dashboard:", userSession.access_token);
//                 const response = await api.get("/dashboard", {
//                     headers: {
//                         Authorization: `Bearer ${userSession.access_token}`,
//                         withCredentials: true,
//                     },
//                 });
//                 const result = response.data;
//                 console.log("Dashboard response:", result);
//                     setDashboard_data(result);

//                 if (result.status === "success") {
//                     setStats({
//                         uploaded: result.data.stat.uploaded || 0,
//                         processing: result.data.stat.inprogress || 0,
//                         published: result.data.stat.published || 0,
//                         corrupted: result.data.stat.failed || 0,
//                     });
//                     const files = result.data.files || [];
//                     console.log("fileupload files", files)
//                     const mappedVideos = files.map((file) => ({
//                         id: file.id,
//                         title: file.name,
//                         //thumbnail: file.thumbnail_url,
//                         thumbnail: file.thumbnail_url ? `${baseUrl}${file.thumbnail_url}` : null,
//                         status: file.status,
//                         video_url: file.video_url,
//                         size: file.size,
//                         progress: file.progress,
//                     }));
//                     console.log("file mappedVideos", mappedVideos);
//                     setRecentVideos(mappedVideos);
//                 } else {
//                                     console.error("Dashboard fetch error:", result.message);

//                     Swal.fire({
//                         icon: "error",
//                         title: "Failed",
//                         text: result.message || "Could not fetch dashboard data.",
//                     });
//                 }
//             } 

//             // catch (error) {
//             //     console.error("Dashboard fetch error:", error);
//             //     Swal.fire({
//             //         icon: "error",
//             //         title: "Error",
//             //         text:
//             //             error.response?.data?.message ||
//             //             "Unable to load dashboard data. Please try again later.",
//             //     });
//             // }
// catch (error) {
//     console.error("Dashboard fetch error:", error);

//     // 🔥 If token expired or unauthorized → redirect to login
//     if (error.response?.status === 401 || 
//         error.response?.data?.message?.toLowerCase().includes("token") ||
//         error.response?.data?.message?.toLowerCase().includes("expired") ||
//         error.response?.data?.message?.toLowerCase().includes("unauthenticated")) 
//     {
//         // Swal.fire({
//         //     icon: "warning",
//         //     title: "Session Expired",
//         //     text: "Please login again.",
//         // });

//         localStorage.removeItem("userSession");  // clear session
//         window.location.href = "/login";         // redirect
//         return;
//     }

//     Swal.fire({
//         icon: "error",
//         title: "Error",
//         text:
//             error.response?.data?.message ||
//             "Unable to load dashboard data. Please try again later.",
//     });
// }
//         };

//         fetchDashboardData();
//     }, [userSession]);

//     return { stats, recentVideos, setRecentVideos,dashboard_data,setDashboard_data };
// }



// src/utils/dashboardStatusLogic.js

import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import api from "../jsx/axiosClient";
 
export function useDashboardStatus(userSession) {

    const baseUrl = "https://stagingapi.chalachitravaachana.org/";

    const [recentVideos, setRecentVideos] = useState([]);

    const [dashboard_data , setDashboard_data] = useState([]);

    const [stats, setStats] = useState({

        uploaded: 0,

        processing: 0,

        published: 0,

        corrupted: 0,

    });
 
    useEffect(() => {

        const fetchDashboardData = async () => {

            if (!userSession?.access_token) return;

            try {

                console.log("access_token Dashboard:", userSession.access_token);

                // 🔥 FIXED: Remove the manual headers object block entirely.

                // Let your global api client attach tokens and session cookies smoothly.

                const response = await api.get("/dashboard");

                const result = response.data;

                console.log("Dashboard response:", result);

                setDashboard_data(result);
 
                if (result.status === "success") {

                    setStats({

                        uploaded: result.data.stat.uploaded || 0,

                        processing: result.data.stat.inprogress || 0,

                        published: result.data.stat.published || 0,

                        corrupted: result.data.stat.failed || 0,

                    });

                    const files = result.data.files || [];

                    const mappedVideos = files.map((file) => ({

                        id: file.id,

                        title: file.name,

                        thumbnail: file.thumbnail_url ? `${baseUrl}${file.thumbnail_url}` : null,

                        status: file.status,

                        video_url: file.video_url,

                        size: file.size,

                        progress: file.progress,

                    }));

                    setRecentVideos(mappedVideos);

                } else {

                    console.error("Dashboard fetch error:", result.message);

                    Swal.fire({

                        icon: "error",

                        title: "Failed",

                        text: result.message || "Could not fetch dashboard data.",

                    });

                }

            } catch (error) {

                console.log("Dashboard fetch error:", error);
 
                if (error.response?.status === 401 || 

                    error.response?.data?.message?.toLowerCase().includes("token") ||

                    error.response?.data?.message?.toLowerCase().includes("expired") ||

                    error.response?.data?.message?.toLowerCase().includes("unauthenticated")) 

                {

                    localStorage.removeItem("userSession");  // clear session

                    window.location.href = "/login";         // seamless background re-login kick-off

                    return;

                }
 
                Swal.fire({

                    icon: "error",

                    title: "Error",

                    text: error.response?.data?.message || "Unable to load dashboard data.",

                });

            }

        };
 
        fetchDashboardData();

    }, [userSession]);
 
    return { stats, recentVideos, setRecentVideos, dashboard_data, setDashboard_data };

}
 